import { amber } from '@mui/material/colors';
import { createStyles, makeStyles } from '@mui/styles';
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import React from 'react';

import { Theme } from '../../styles/theme';
import SnackbarContainer from './SnackbarContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.sizes.header.height,
    },
    variantSuccess: {
      backgroundColor: theme.colors.olive,
    },
    variantError: {
      backgroundColor: theme.colors.fuchsia,
    },
    variantInfo: {
      backgroundColor: theme.colors.blue,
    },
    variantWarning: {
      backgroundColor: amber[400],
    },
  })
);

function SnackbarProvider() {
  const classes = useStyles();
  return (
    <NotistackSnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      classes={classes}
    >
      <SnackbarContainer />
    </NotistackSnackbarProvider>
  );
}

export default SnackbarProvider;
